<template>
  <!-- 用户下级管理 -->
  <div>
    <el-row>
      <el-col class="pull-left" style="width: 200px; margin-right: 20px">
        <el-input
          size="small"
          v-model="params.uid"
          placeholder="用户UID"
        ></el-input>
      </el-col>
      <el-col class="pull-left" style="width: 200px; margin-right: 20px">
        <el-input
          size="small"
          v-model="params.name"
          placeholder="用户名称"
        ></el-input>
      </el-col>
      <el-col class="pull-left" style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="params.start_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始时间"
        >
        </el-date-picker>
      </el-col>
      <el-col class="pull-left" style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="params.end_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始时间"
        >
        </el-date-picker>
      </el-col>
      <el-button
        size="small"
        class="pull-left"
        type="primary"
        @click="handleSearch"
        >搜索
      </el-button>
    </el-row>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column prop="user_id" label="用户ID"></el-table-column>
      <el-table-column prop="ratio" label="主播比"></el-table-column>
      <el-table-column prop="created_at" label="修改时间"></el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="page"
      @current-change="handlePageChange"
      v-if="dataMeta && dataMeta.total > dataMeta.per_page"
    ></el-pagination>
  </div>
</template>

<script>
import { getApiData } from '../../http'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      dataList: undefined,
      dataMeta: {},
      loading: false,
      page: 1,
      params: {
        uid: undefined,
        name: undefined,
        start_time: undefined,
        end_time: undefined
      }
    }
  },

  methods: {
    handleSearch() {
      this.page = 1
      this.getTableData()
    },
    getTableData() {
      this.loading = true
      getApiData(`user_anchor/${this.id}`, { page: this.page, uid: this.params.uid, name: this.params.name, start_time: this.params.start_time, end_time: this.params.end_time })
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.page = page
      this.getTableData()
    },
    handleTypeChange() {
      this.page = 1
      this.getTableData()
    }
  },
  created() {
    this.getTableData()
  }
}
</script>

<style>
</style>
